<template>
  <ModalDialog @closeDialog="handleCloseDialog">
    <div class="purpose">
      Terms & Conditions
    </div>
    <form @submit.prevent="handleCloseDialog">
      <div class="formSection">
        <div class="details">
          <div class="rstudio-legacy-orb" />
          <p>
            © 2021 <a
              href="https://www.rstudio.com/"
              target="_blank"
            >RStudio, PBC</a> | All Rights Reserved | <a
              href="https://www.rstudio.com/about/rstudio-service-terms-of-use/"
              target="_blank"
            >Legal Terms</a>
          </p>
          <p v-if="build_date">
            Built on {{ buildDate }}
          </p>
          <p style="margin-bottom: 0px; margin-top: 20px;">
            Disclaimer for External Packages
          </p>
          <p style="font-size: 13px;">
            RStudio Package Manager enables customers to access, download and use third party open source software applications (referred to as “R Packages” or "Python Packages"). These R Packages or Python Packages may be subject to license terms from the author and any such license terms will be made available in the description of the R Package or Python Package. These R Packages or Python Packages are “third party applications” as referred to in the Agreement and RStudio expressly disclaims any and all express, implied and statutory representations and warranties and any and all liability with respect to R Packages or Python Package and your download and use thereof, all of which are made available “as is”.
          </p>
        </div>
      </div>
      <div class="actions">
        <button type="submit">
          OK
        </button>
      </div>
    </form>
  </ModalDialog>
</template>

<script>

import ModalDialog from './ModalDialog'
import { mapState } from 'vuex'
import { parseTimeToString } from '../../utils/time'

export default {
  name: 'TermsDialog',
  components: {
    ModalDialog,
  },
  computed: {
    ...mapState({
      build_date: state => state.status.build_date,
    }),
    buildDate: function () {
      return parseTimeToString(this.build_date, false, { showTime: false })
    },
  },
  methods: {
    handleCloseDialog: function () {
      this.$emit('closeDialog', null)
    },
  },
}

</script>
